import useTranslation from 'next-translate/useTranslation'
import SalaryChartSpread from './SalaryChartSpread'
import { renderValues } from '../../libs/helpers/reportUtils'

interface IProps {
  spread: number[][]
  value: number[]
  type: string
  className: string
}
const SalaryChartItem = ({ spread, value, type, className }: IProps) => {
  const { t, lang } = useTranslation()
  const min = Math.min(...spread.flat())
  const max = Math.max(...spread.flat())

  const spreadKey = spread.length > 1 ? 'spread-brackets' : 'spread-single'

  return (
    <div
      className={`rounded-2xl text-white p-6 text-center w-full md:w-1/2 ${className}`}
    >
      <div className='font-bold uppercase'>
        {t(`it_report:salary-report-${type}`)}
      </div>
      <div className='font-bold text-5xl'>{renderValues(value, lang)}</div>
      <div className='font-thin text-xs'>
        {t(`it_report:salary-report-per-month-${type}`)}
      </div>
      <div className='mt-8'>
        {spread.map((items, index) => (
          <SalaryChartSpread
            min={min}
            max={max}
            p25={items[0]}
            p75={items[1]}
            lang={lang}
            tooltip={t(`it_report:salary-${spreadKey}-${index}`)}
          />
        ))}
      </div>
    </div>
  )
}

export default SalaryChartItem
